import React, { memo, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import "../pages/dashboard.css";
import { AUTO, CHILD, CP, FOOD, MEDICINE, PRESS } from "../assets/constant";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSearchParams } from "react-router-dom";

function FilterComponent() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filterState, setFilterState] = useState({});

  const debounceTimeout = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilterState((prev) => ({ ...prev, [name]: value }));

    clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        if (value) {
          newParams.set(name, value);
        } else {
          newParams.delete(name);
        }
        return newParams;
      });
    }, 600);
  };

  const clearFilters = () => {
    setFilterState({});
    setSearchParams({});
  };

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 20 }, (_, i) => currentYear - i);
  const classificationOptions = [
    "Class I",
    "Class II",
    "Class III",
    "Not Yet Classified"
  ];
  const tabSelected = searchParams.get("tab");

  useEffect(() => {
    const params = Object.fromEntries(searchParams.entries());
    setFilterState(params);
  }, [searchParams]);

  return (
    <div className="filter-container">
      {tabSelected === AUTO && (
        <>
          <div className="filter-input">
            <i className="fa fa-industry"></i>
            <input
              type="text"
              placeholder="Manufacturer"
              name="manufacturer_or_make"
              value={filterState?.manufacturer_or_make}
              onChange={handleInputChange}
            />
          </div>

          <div className="filter-input">
            <i className="fa fa-cogs"></i>
            <input
              type="text"
              placeholder="Components"
              name="component"
              value={filterState?.component}
              onChange={handleInputChange}
            />
          </div>

          <div className="filter-input">
            <i className="fa fa-car"></i>
            <input
              type="text"
              placeholder="Model"
              name="model"
              value={filterState?.model}
              onChange={handleInputChange}
            />
          </div>

          <div className="filter-input">
            <i className="fa fa-calendar"></i>
            <select
              name="model_year"
              value={filterState?.model_year}
              onChange={handleInputChange}
              className="form-control">
              <option value="">Model Year</option>
              {yearOptions.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </>
      )}

      {(tabSelected === FOOD || tabSelected === MEDICINE) && (
        <>
          <div className="filter-input">
            <i className="fa fa-industry"></i>
            <input
              type="text"
              placeholder="Search"
              name="q"
              value={filterState?.q ?? ""}
              onChange={handleInputChange}
            />
          </div>

          <div className="filter-input">
            <select
              name="classification"
              value={filterState?.classification}
              onChange={handleInputChange}
              className="form-control">
              <option value="">Select Type</option>
              {classificationOptions.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
            <i className="fa fa-caret-down"></i>
          </div>
        </>
      )}

      {(tabSelected === PRESS ||
        tabSelected === CHILD ||
        tabSelected === CP) && (
        <div className="filter-input">
          <i className="fa fa-industry"></i>
          <input
            type="text"
            placeholder="Search"
            name="q"
            value={filterState?.q ?? ""}
            // value={filterData?.q ?? ""}
            onChange={handleInputChange}
          />
        </div>
      )}

      <div className="filter-input">
        <i className="fa fa-calendar-alt"></i>
        {/* <input
          type="date"
          key={`${filterState?.from_date}-${tabSelected}`}
          name="from_date"
          value={filterState?.from_date ?? ""}
          onChange={handleInputChange}
          className="form-control"
          placeholder="Start Date"
          style={{ color: filterData?.from_date ? "inherit" : "#999" }}
          max={new Date().toISOString().split("T")[0]}
        /> */}
        <ReactDatePicker
          selected={
            filterState?.from_date ? new Date(filterState.from_date) : null
          }
          onChange={(date) =>
            handleInputChange({
              target: {
                name: "from_date",
                value: date ? date.toISOString().split("T")[0] : ""
              }
            })
          }
          className="form-control"
          placeholderText="From Date"
          maxDate={new Date()}
        />
      </div>

      <div className="filter-input">
        <i className="fa fa-calendar-alt"></i>
        {/* <input
          type="date"
          name="to_date"
          value={filterState?.to_date ?? ""}
          onChange={handleInputChange}
          className="form-control"
          placeholder="End Date"
          style={{
            color: filterData?.to_date ? "inherit" : "#999",
            appearance: "none",
            backgroundSize: "20px",
            paddingRight: "30px"
          }}
          max={new Date().toISOString().split("T")[0]}
        /> */}
        <ReactDatePicker
          selected={filterState?.to_date ? new Date(filterState.to_date) : null}
          onChange={(date) =>
            handleInputChange({
              target: {
                name: "to_date",
                value: date ? date.toISOString().split("T")[0] : ""
              }
            })
          }
          className="form-control"
          placeholderText="End Date"
          maxDate={new Date()}
        />
      </div>

      <button className="clear-button" onClick={clearFilters}>
        Clear All
      </button>
    </div>
  );
}
FilterComponent.propTypes = {
  updateFilter: PropTypes.func.isRequired,
  tabSelected: PropTypes.string.isRequired
};

export default memo(FilterComponent);
